export default __webpack_public_path__ + "images/favicon.68ee5d7a6f.ico";